import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { navigate } from '@reach/router';

import Container from 'src/components/Container'
import {
  round1,
  round2,
  round3,
  round4
} from 'src/components/AnimationKeyframes'

import Button from 'src/components/atoms/Button'

import Ellipse11 from 'src/assets/images/vectors/ellipse-11.svg'
import Ellipse12 from 'src/assets/images/vectors/ellipse-12.svg'
import Ellipse13 from 'src/assets/images/vectors/ellipse-13.svg'
import Vector1LP from 'src/assets/images/vectors/vector-1-lp.svg'
import Vector2 from 'src/assets/images/vectors/vector-2.svg'
import Vector3 from 'src/assets/images/vectors/vector-3.svg'

import { LANDING_PAGE_SECTIONS } from 'src/utils/paths'

export const WelcomeSection = props => {
  const scrollToSection = id => () => {
    navigate(`/#${id}`)
  }

  return (
    <MainSectionContainer>
      <Container>
        <div className='d-flex-desktop'>
          <Images></Images>
          <Content navigate={scrollToSection(LANDING_PAGE_SECTIONS.howItWorksSection)}></Content>
        </div>
      </Container>
    </MainSectionContainer>
  )
}

export default WelcomeSection

const MainSectionContainer = styled.div`
  padding-top: ${props => props.theme.dimensions.navHeight};
  position: relative;
  box-sizing: border-box;
  width: 100%;

  .d-flex-desktop {
    ${props => props.theme.breakpointsMedia.desktop} {
      display: flex;
      padding: 0 24px;
    }
  }

  .content {
    z-index: 1;
    padding: 0 20px;
    width: 330px;
    margin: 0 auto;
    text-align: center;

    ${props => props.theme.breakpointsMedia.desktop} {
      padding: 0;
      padding-top: 60px;
      width: auto;
      margin: unset;
      text-align: unset;
    }

    h1 {
      font-size: 36px;
      line-height: 1.5;
    }

    p {
      font-weight: 500;
      font-size: 16px;
      padding: 32px 0;
      line-height: 1.5;

      ${props => props.theme.breakpointsMedia.desktop} {
        padding: 16px 0;
      }
    }

    button {
      width: 136px;
      margin-top: 16px;
    }

    ${props => props.theme.breakpointsMedia.desktop} {
      width: 40%;
      order: 0;

      h1 {
        font-size: 48px;
      }
    }

    .header-part__regular {
      font-weight: 300;
    }

    .header-part__bold {
      font-weight: 700;
    }
  }

  .images {
    height: 270px;
    z-index: 0;

    img {
      position: absolute;

      &.vector-1-lp {
        width: 500px;
        top: -250px;
        right: 0;
        animation: ${round1} 8s linear infinite;
      }

      &.vector-3 {
        width: 204px;
        top: 10px;
        left: calc(50vw - 100px);
        animation: ${round2} 6s linear infinite;
      }

      &.ellipse-11 {
        width: 266px;
        top: 50px;
        left: calc(50vw - 150px);
        animation: ${round3} 6s linear infinite;
      }

      &.ellipse-12 {
        width: 12px;
        top: 40px;
        left: calc(50vw + 100px);
        animation: ${round4} 8s linear infinite;
      }

      &.ellipse-13 {
        width: 12px;
        top: 100px;
        left: calc(50vw - 140px);
        animation: ${round2} 8s linear infinite;
      }

      &.vector-2 {
        width: 300px;
        top: 50px;
        left: calc(50vw - 150px);
        animation: ${round3} 10s linear infinite;
      }
    }

    ${props => props.theme.breakpointsMedia.desktop} {
      height: 400px;
      width: 60%;
      order: 1;

      img {
        &.vector-1-lp {
          width: 650px;
          top: -200px;
          left: unset;
          right: 0;
        }

        &.vector-3 {
          width: 444px;
          top: 40px;
          left: calc(100vw - 670px);
        }

        &.ellipse-11 {
          width: 500px;
          top: 130px;
          left: calc(100vw - 820px);
        }

        &.ellipse-12 {
          width: 27px;
          top: 160px;
          left: calc(100vw - 200px);
        }

        &.ellipse-13 {
          width: 27px;
          top: 240px;
          left: calc(100vw - 810px);
        }

        &.vector-2 {
          width: 700px;
          top: 130px;
          left: calc(100vw - 805px);
        }
      }
    }
  }
`

const Images = props => <>
  <div className='images'>
    <img
      className='vector-1-lp'
      src={Vector1LP}
      alt='vector-1-lp'
    />
    <img
      className='vector-3'
      src={Vector3}
      alt='vector-3'
    />
    <img
      className='ellipse-11'
      src={Ellipse11}
      alt='ellipse-11'
    />
    <img
      className='ellipse-12'
      src={Ellipse12}
      alt='ellipse-12'
    />
    <img
      className='ellipse-13'
      src={Ellipse13}
      alt='ellipse-13'
    />
    <img
      className='vector-2'
      src={Vector2}
      alt='vector-2'
    />
  </div>
</>

const Content = props => {
  const { t } = useTranslation()

  return (
    <div className='content'>
      <h1>
        <span className='header-part__regular'>{t('landingPage.welcomeSection.welcomeText1')}</span>
        <br className='tablet-up' />
        <span className='header-part__regular'>{t('landingPage.welcomeSection.welcomeText2')}</span>
        <br />
        <span className='header-part__bold'>{t('landingPage.welcomeSection.welcomeText3')}</span>
        <br />
        <span className='header-part__bold'>{t('landingPage.welcomeSection.welcomeText4')}</span>
        <br />
      </h1>
      <p>{t('landingPage.welcomeSection.checkSteps')}</p>
      <Button onClick={props.navigate} size='large'>{t('landingPage.welcomeSection.ctaButton')}</Button>
    </div>
  )
}
